/* eslint-disable max-len */
import { useState } from 'react';
import { Drawer } from 'antd';
import styled from 'styled-components';
import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import {
  primaryHeadingColor,
  scrollbar, secondaryFont, wMedium, maxWidth, retina, wMBold, maxTablet,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import ArrowRightIcon from 'Components/common/assets/svgIcons/ArrowRightIcon';
import TagTip from 'Components/common/components/TagTip';
import SmallButton from 'Components/common/components/SmallButton';
import SmartSourcedContentPopup from 'Components/common/modal/SmartSourcedContentPopup';
import ModalWidget from 'Components/common/modal/ModalWidget';
import { useSelector } from 'react-redux';
import { personIntentData } from 'Selector/PersonProfileSelector';
import { isGuest } from 'Utils/UtilityFunctions';

const Wrapper = styled.div`

`;

const ScrollWrapper = styled.div`
  margin: 0px 10px 0 20px;
  padding: 10px 10px 10px 20px;
  height: calc(100vh - 170px);
  ${scrollbar};
  @media all and (max-width: ${maxWidth}) , ${retina}{
    margin-top:0px;
    height: calc(100vh - 100px);
  }
  &.marginTop{
    margin: 10px 10px 0 20px;
  }
  .buttons-part{
    margin:32px 24px 0 24px;
    button{
      &:active{
      box-shadow: none;
      }
      &:focus {
        box-shadow: none;
      }
    }
  }
`;

const Heading = styled.h3`
  font-family: ${secondaryFont};
  font-size: 46px;
  line-height: 44px;
  color: ${primaryHeadingColor};
  font-weight: ${wMBold};
  margin-bottom: 0px;
  padding: 0px 0px 0 16px;
  @media all and (max-width: ${maxWidth}) , ${retina}{
    font-size: 24px;
    line-height: 26px;
  }
  &.mb-head {
    margin-bottom: 0px;
    &.skills {
      margin-top: 14px;
    }
  }
`;

const BrowseAll = styled.span`
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    top: 10px;
  }
  @media all and (max-width: ${maxTablet}) {
    top: 6px;
  }
`;

const LearnMore = styled.span`
  font-size: 14px;
  font-weight: ${wMedium};
  font-family: ${secondaryFont};
  line-height: 36px;
  letter-spacing: -0.35px;
  color: #424B50;
  display: flex;
  align-items: center;
  pointer-events: none;
  @media all and (max-width: ${maxTablet}) {
   font-size: 12px;
  }
  svg {
    margin-left: 10px;
    margin-top: 3px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-left: 5px;
      width:12px;
    }
    path {
     fill: #424B50;
    }
  }
`;

type Props = {
  keywords?: string[],
  title?: string,
  titleOne?: string,
  buttons?: boolean,
  headingMargin?: boolean,

} & typeof defaultProps;

const defaultProps = {
  keywords: [''],
  title: '',
  titleOne: '',
  buttons: false,
  headingMargin: false,

};

const DrawerPersonIntent = function DrawerPersonIntent(props: Props) {
  const [visible, setVisible] = useState(false);
  const {
    title, titleOne, buttons, keywords, headingMargin,
  } = props;
  const {
    data, intentAllowed, url,
  } = useSelector(personIntentData);

  const toggle = () => {
    setVisible(!visible);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showSmartContentPopup, setShowSmartContentPopup] = useState(false);
  const handleOnClickSmartContent = () => {
    setShowSmartContentPopup(true);
  };
  const handleGenerateSmartContent = () => {
    if (intentAllowed && !isGuest()) {
      window.open(url, '_blank');
    } else {
      setIsModalVisible(true);
    }
  };

  return (
    <Wrapper>

      {showSmartContentPopup ? (
        <SmartSourcedContentPopup
          width="801px"
          description="SmartSourced ™  Content, developed by xiQ, is intelligent content about the interests and topics that matter to each prospect. It is intelligently sourced, curated, and uses proprietary AI to extract insights, from the most reputable sources and combine with your own marketing collateral, about every individual prospect!"
          onClickCancel={() => setShowSmartContentPopup(false)}
          showSmartContentPopup={showSmartContentPopup}
        />
      ) : null}
      {
        isModalVisible ? (
          <ModalWidget
            onClickNext={() => window.open('mailto:support@xiqinc.com')}
            onClickCancel={() => setIsModalVisible(false)}
            cancelText="Close"
            nextText="Contact Us"
            width="530px"
            title="Access Required"
            closePopup={false}
            nextLoading={false}
            description=""
            borderedButtons
          >
            <p className="main-message">You need to purchase xiQ’s AI powered ABM platform to generate content.</p>
          </ModalWidget>
        ) : null
      }
      <BrowseAll onClick={toggle} className={classNames({ drawerBoxOpen: visible })}>
        <LearnMore className="learn-more-text">
          See all
          <ArrowRightIcon />
        </LearnMore>
      </BrowseAll>
      <Drawer
        rootClassName="drawer-alerts people-group-drawer intent-drawer-wrapper"
        placement="right"
        open={visible}
        onClose={toggle}
        width={530}
        extra={(
          <div className="d-flex justify-content-between">
            <Heading className={classNames('mb-head', { skills: headingMargin })}>{title}</Heading>
            <span
              onClick={toggle}
              onKeyPress={toggle}
              tabIndex={0}
              role="button"
              aria-label="close"
              className="close-alerts mt-2"
            >
              <CloseAlerts />
            </span>
          </div>
        )}
      >

        {titleOne && <Heading>{titleOne}</Heading>}
        {/* <Heading className="mb-head">{title}</Heading> */}
        <ScrollWrapper className={classNames({ marginTop: !headingMargin })}>
          {!buttons ? keywords.map((keyword) => (
            <TagTip key={keyword} title={keyword} />
          ))
            : data.map((keyword) => (
              <TagTip key={keyword} title={keyword} />
            ))}
          {buttons && (
            <div className="buttons-part d-flex flex-column justify-content-center">
              <SmallButton
                variant="filled"
                color="#001760"
                title="Generate SmartContent in Workbench"
                onButtonClick={handleGenerateSmartContent}

              />
              <SmallButton
                variant="text"
                color="#001760"
                title="What is SmartContent?"
                onButtonClick={handleOnClickSmartContent}
              />
            </div>
          )}
        </ScrollWrapper>
      </Drawer>
    </Wrapper>
  );
};

DrawerPersonIntent.defaultProps = defaultProps;
export default DrawerPersonIntent;
